<!-- LoginPage.vue -->
<template>
    <div class="login-container">
      <div class="logo-section">
        <img src="@/assets/Ansable.svg" alt="Ansable VT" class="logo">
      </div>
  
      <div class="login-section">
        <div class="login-with">
          <div class="line"></div>
          <span>Login or Sign Up with</span>
          <div class="line"></div>
        </div>
  
        <div v-if="showLoginOptions" class="login-buttons">
            <button class="login-button">
                <img @click="signIn" src="@/assets/Google Logo.svg" alt="Login with Google">
            </button>
            <!-- <button class="login-button" @click="signInFacebook">
                <img src="@/assets/meta.svg" alt="Login with Meta">
            </button> -->
            <button class="login-button" @click="showEmailLogin">
                <img src="@/assets/email.svg" alt="Login with Email">
            </button>
        </div>

        <div v-else class="email-login">
            <input type="email" placeholder="Enter your email address" v-model="email" class="input-box"/>
            <input type="password" placeholder="Enter or create your password" v-model="password" class="input-box"/>

            <div class="action-buttons">
            <button class="action-button" @click="signInWithEmail">Login</button>
            <button class="action-button" @click="showLoginOptions = true">
                Return to Login Options
            </button>
            </div>
        </div>
      </div>
    </div>
  </template>

<script>
import { auth, db } from '@/firebase';
// import { signInWithPopup, GoogleAuthProvider, FacebookAuthProvider, signInWithEmailAndPassword, createUserWithEmailAndPassword} from 'firebase/auth';
import { signInWithPopup, GoogleAuthProvider, signInWithEmailAndPassword, createUserWithEmailAndPassword} from 'firebase/auth';
import { doc, setDoc, getDoc } from 'firebase/firestore';
import { useRouter } from 'vue-router';
import { ref } from 'vue';

export default {
  name: 'LoginPage',
  setup() {
    const router = useRouter();
    const email = ref('');
    const password = ref('');
    const showLoginOptions = ref(true);

    const createOrUpdateUser = async (user) => {
      const userRef = doc(db, 'users', user.uid);
      const userSnap = await getDoc(userRef);

      if (!userSnap.exists()) {
        // New user - create a new document
        await setDoc(userRef, {
          email: user.email,
          displayName: user.displayName,
          photoURL: user.photoURL,
          createdAt: new Date(),
          lastLogin: new Date(),
          isNewUser: true
        });
        // Redirect to user information page
        router.push('/welcome');
      } else {
        // Existing user - update last login
        await setDoc(userRef, { lastLogin: new Date() }, { merge: true });
        // Redirect to dashboard or home page
        router.push('/home');
      }
    };

    // Sign-in method with Google
    const signIn = async () => {
      try {
        // Initiate Google Sign-In
        const provider = new GoogleAuthProvider();
        const result = await signInWithPopup(auth, provider);
        // console.log('User signed in successfully:', result.user);

        // Create or update user in Firestore
        await createOrUpdateUser(result.user);
      } catch (error) {
        console.error('Error during sign-in:', error);
        alert('Failed to sign in. Please check the console for more details.');
      }
    };

    // Facebook
    /* const signInFacebook = async () => {
      try {
        // Initiate Facebook Sign-In
        const provider = new FacebookAuthProvider();
        const result = await signInWithPopup(auth, provider);

        // Create or update user in Firestore
        await createOrUpdateUser(result.user);
      } catch (err) {
        console.error('Facebook sign-in error:', err);
        alert('Failed Facebook sign-in.');
      }
    }; */

    const signInWithEmail = async () => {
  try {
    // First try to sign in
    const userCredential = await signInWithEmailAndPassword(
      auth,
      email.value,
      password.value
    );
    await createOrUpdateUser(userCredential.user);
  } catch (error) {
    if (error.code === 'auth/invalid-credential') {
      // If credentials are invalid, try to create new account
      try {
        const newUserCredential = await createUserWithEmailAndPassword(
          auth,
          email.value,
          password.value
        );
        await createOrUpdateUser(newUserCredential.user);
      } catch (createError) {
        if (createError.code === 'auth/email-already-in-use') {
          alert('This email is registered with Google or Facebook. Please try those login options.');
          showLoginOptions.value = true;
          email.value = '';
          password.value = '';
        } else {
          console.error('Create account error:', createError);
          alert('Error creating account. Please try again.');
        }
      }
    } else {
      console.error('Sign in error:', error);
      alert('Error signing in. Please try again.');
    }
  }
};

    const showEmailLogin = () => {
      showLoginOptions.value = false;
    };

    return {
      email,
      password,
      showLoginOptions,
      signIn,
      // signInFacebook,
      signInWithEmail,
      showEmailLogin,
    };
  }
}
</script>

<style scoped>
.login-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #fffff8;
}

.logo-section {
  margin-bottom: 4rem;
  transform: translateY(-10%);
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 0 2rem;
}

.logo-section img {
  width: 80%;
  max-width: 42rem;
  height: auto;
}

.login-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 22.3rem;
}

.login-with {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 2rem;
  color: #545051;
}

.line {
  flex: 1;
  width: 4rem;
  height: 1px;
  background-color: #545051;
}

.login-with span {
  padding: 0 1rem;
  font-size: 1.667rem;
}

.login-buttons {
  display: flex;
  justify-content: center;
  width: 85%;
  gap: 3rem;
}

.login-button {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  width: 3rem;
  height: 3rem;
}

.login-button img {
  width: 100%;
  height: 100%;
}

.login-button:hover {
  opacity: 0.9;
}

.email-login {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: flex-start;
  width: 85%;
}

.input-box {
  border: none;
  border-bottom: 1px solid #545051;
  width: 100%;
  padding: 0.5rem 0;
  font-size: 14pt;
  color: #545051;
  padding-left: 0.5rem;
  background-color: #fffff8;
}

.input-underline {
  border: none;
  border-bottom: 1px solid #545051;
  width: 100%;
  padding: 0.5rem;
  font-size: 14pt;
}

.input-underline:focus {
  outline: none;
  border-bottom: 1px solid #000;
}

.action-buttons {
  display: flex;
  flex-direction: column; /* Stack buttons vertically */
  align-items: center; /* Center the buttons */
  gap: 1rem; /* Add spacing between the buttons */
  width: 100%; /* Optional: match parent width */
}

.action-button {
  border: 1px solid #545051;
  padding: 0.5rem 1rem;
  background: none;
  cursor: pointer;
  font-size: 14pt;
  border-radius: 10px;
  width: 100%; /* Optional: match button width to parent */
}

.action-button:hover {
  background-color: #f5f5f5;
}

.input-box:-webkit-autofill {
  box-shadow: 0 0 0px 1000px #fffff8 inset; /* Match your background color */
  -webkit-text-fill-color: #545051; /* Match your input text color */
}
</style>